<template>
    <div>
        <!-- 公共picker -->
        <md-picker1
            ref="picker0"
            v-model="isPickerShow0"
            :data="typeList"
             :cols="cols"
             :is-cascade="true"
            :default-index="pickerDefaultIndex"
            :default-value="pickerDefaultValue"
            :isShowAbountButton="isShowAbountButton"
            @confirm="onPickerConfirm1()"
            @setAbountTime="setAbountTime"
            >
        </md-picker1>
    </div>
</template>
<script>
    import mdPicker from '../../components/picker/index'
    export default {
        components: {
            'md-picker1': mdPicker
        },
        props: {
            isShowAbountButton: {// 控制显示是否有自定义按钮
                type: Boolean,
                default: false
            },
            typeList: {// 数据源
                type: Array,
                default: null
            },
            cols: {// 列数
                type: Number,
                default: 1
            },
            pickerDefaultValue: {
                type: Array,
                default: ()=>[]
            },
            pickerDefaultIndex: {
                type: Array,
                default: ()=>[]
            }
        },
        data () {
            return {
                isPickerShow0: false,
                pickerData0: [
                ],
            }
        },
        methods: {
            setAbountTime () {
                this.$emit('showRangTime');
                this.isPickerShow0 = false;
            },
            showPicker () {
                this._initFresh();
                this.isPickerShow0 = true;
            },
            onPickerConfirm1 () {
                const values = this.$refs.picker0.getColumnValues();
                this.$emit('getTypeValue', values);
            },
            _initFresh () {
                this.$refs.picker0.refresh();
            }
        }
    }
</script>
<style>
/* 初始化插件的样式 */
.mint-datetime-action {
    width:30%;
}
.picker-toolbar span:nth-child(1){
    color:#999;
}
.picker-toolbar span:nth-child(2){
    color:#4B77B0;
}
.mint-datetime .picker-toolbar{
    border:none;
}
.md-popup-title-bar[data-v-6bac428c]{
    height:40px;
}
.md-popup-title-bar .title-bar-left[data-v-6bac428c], .md-popup-title-bar .title-bar-right[data-v-6bac428c]{
    font-size:14px;
}
.md-popup-title-bar .title-bar-left[data-v-6bac428c], .md-popup-title-bar .title-bar-right[data-v-6bac428c]{
    height:40px;

}
.md-popup-title-bar>div[data-v-6bac428c]{
    padding-top:20px;
}
.md-picker-column-item .column-list .column-item{
    padding: 0 14px;
    font-size:16px;
}
.md-picker-column-item .column-list .column-item{
    font-size:16px!important;
    padding: 0 14px!important;
}
</style>
